import { ACTIONS } from "./../constants"


const initialState = { 
  supportAssessmentTools: [], 
  supportAssessmentTool: {}, 
  totalSize: 0,
  isFetching: false, 
  isLoading: false,
  hasMore: true, 
  success: {
    isDeactivated: false,
    isActivated: false,
    isCreated: false,
    isUpdated: false,
    isDeleted :false,
  },
  error: null
}


export default (state = initialState , action) => {
  const { payload, type } = action
  switch (type) {

    case ACTIONS.CLEAR_SUPPORT_ASSESSMENT_TOOL : {
      return { ...state, success: initialState.success, error: null, isFetching: false, isLoading: false }
    }

    case ACTIONS.FETCH_SUPPORT_ASSESSMENT_TOOLS_INIT : {
      return { ...state, isFetching: true, error: null }
    }
    case ACTIONS.FETCH_SUPPORT_ASSESSMENT_TOOLS_SUCCEDED : {
      const { count, results } = payload
      return { ...state, totalSize: count, supportAssessmentTools: results, isFetching: false, error: null }
    }
    case ACTIONS.FETCH_SUPPORT_ASSESSMENT_TOOLS_FAILED : {
      return { ...state, isFetching: false, error: payload }
    }

    case ACTIONS.CREATE_SUPPORT_ASSESSMENT_TOOL_INIT : {
      return { ...state, isLoading: true, error: null, success: initialState.success }
    }
    case ACTIONS.CREATE_SUPPORT_ASSESSMENT_TOOL_SUCCEDED : {
      return { ...state, success: { ...state.success, isCreated: true }, isLoading: false, error: null }
    }
    case ACTIONS.CREATE_SUPPORT_ASSESSMENT_TOOL_FAILED : {
      return { ...state, error: payload, isLoading: false }
    }

    case ACTIONS.EDIT_SUPPORT_ASSESSMENT_TOOL_INIT : {      
      return { ...state, isLoading: true, error: null, success: initialState.success }
    }
    case ACTIONS.EDIT_SUPPORT_ASSESSMENT_TOOL_SUCCEDED : {
      return { ...state, success: { ...state.success, isUpdated: true }, isLoading: false, error: null }
    }
    case ACTIONS.EDIT_SUPPORT_ASSESSMENT_TOOL_FAILED : {
      return { ...state, error: payload, isLoading: false }
    }
 
    case ACTIONS.FETCH_SUPPORT_ASSESSMENT_TOOL_INIT : {
      return { ...state, isLoading: true, success: initialState.success, supportAssessmentTool: null, error: null }
    }
    case ACTIONS.FETCH_SUPPORT_ASSESSMENT_TOOL_SUCCEDED : {
      return { ...state, supportAssessmentTool: payload, isLoading: false, error: null }
    }
    case ACTIONS.FETCH_SUPPORT_ASSESSMENT_TOOL_FAILED : {
      return { ...state, isLoading: false, error: payload }
    }

    case ACTIONS.DEACTIVATE_SUPPORT_ASSESSMENT_TOOL_INIT : {
      return { ...state, isLoading: true, success: initialState.success, error: null }
    }
    case ACTIONS.DEACTIVATE_SUPPORT_ASSESSMENT_TOOL_SUCCEDED : {
      return { ...state, success: { ...state.success, isDeactivated: true }, isLoading: false, error: null }
    }
    case ACTIONS.DEACTIVATE_SUPPORT_ASSESSMENT_TOOL_FAILED : {
      return { ...state, isLoading: false, error: payload }
    }

    case ACTIONS.ACTIVATE_SUPPORT_ASSESSMENT_TOOL_INIT : { 
      return { ...state, isLoading: true, success: initialState.success, error: null }
    }
    case ACTIONS.ACTIVATE_SUPPORT_ASSESSMENT_TOOL_SUCCEDED : {
      return { ...state, success: { ...state.success, isActivated: true }, isLoading: false, error: null }
    }
    case ACTIONS.ACTIVATE_SUPPORT_ASSESSMENT_TOOL_FAILED : {
      return { ...state, isLoading: false, error: payload }
    }
    case ACTIONS.DELETE_SUPPORT_ASSESSMENT_TOOL_INIT : {
      return { ...state, isLoading: true, success: initialState.success, error: null }
    }
    case ACTIONS.DELETE_SUPPORT_ASSESSMENT_TOOL_SUCCEDED : {
      return { ...state, success: { ...state.success, isDeleted: true }, isLoading: false, error: null }
    }
    case ACTIONS.DELETE_SUPPORT_ASSESSMENT_TOOL_FAILED : {
      return { ...state, isLoading: false, error: payload }
    }
    default: {
      return state
    }
  }
}
